import { useEffect, useState } from 'react';
import api from '../../../services/api';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import Modal from '../../ui/Modal';
import { useWarehouseLabels } from '../warehouseLabels';

/**
 * Re-confirmação de senha antes de salvar o Editor de galpão (r3): o layout
 * amarra o mapa aos endereços reais, então salvar exige provar que quem está
 * na sessão é o dono dela. Fluxo: senha → POST /auth/confirm-password →
 * 200 chama `onConfirmed()` (o chamador faz o PUT); 401 vira erro NO CAMPO
 * (o backend responde `REAUTH_REQUIRED`, que o api.js propaga sem derrubar a
 * sessão); cancelar/fechar NÃO salva nada.
 */
const ConfirmPasswordModal = ({ isOpen, onClose, onConfirmed }) => {
    const { label } = useWarehouseLabels();
    const [password, setPassword] = useState('');
    const [fieldError, setFieldError] = useState(null);
    const [checking, setChecking] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setPassword('');
            setFieldError(null);
            setChecking(false);
        }
    }, [isOpen]);

    const close = () => {
        if (!checking) {
            onClose();
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!password) {
            setFieldError(label('wms.common.required'));
            return;
        }
        setChecking(true);
        setFieldError(null);
        try {
            await api.confirmPassword(password);
            onConfirmed();
        } catch (error) {
            if (error?.status === 401 || error?.code === 'REAUTH_REQUIRED') {
                setFieldError(label('wms.map.password_wrong'));
            } else {
                setFieldError(error?.message || label('wms.common.load_error'));
            }
            setChecking(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={close} title={label('wms.map.confirm_password_title')} size="sm">
            <form onSubmit={handleSubmit} className="space-y-4">
                <p className="text-sm text-mono-600 dark:text-mono-400">{label('wms.map.confirm_password_hint')}</p>
                <Input
                    label={label('wms.map.password')}
                    type="password"
                    value={password}
                    onChange={(event) => {
                        setPassword(event.target.value);
                        setFieldError(null);
                    }}
                    errorMessage={fieldError || undefined}
                    autoFocus
                    autoComplete="current-password"
                    disabled={checking}
                />
                <div className="flex flex-col gap-3 sm:flex-row">
                    <Button type="submit" loading={checking} className="flex-1">
                        {label('wms.map.confirm_and_save')}
                    </Button>
                    <Button type="button" variant="secondary" onClick={close} disabled={checking}>
                        {label('wms.common.cancel')}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};

export default ConfirmPasswordModal;
